<template>
  <v-container fluid>
    <template>
      <v-card class="mt-4">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
            <v-spacer/>
            <v-btn
            icon
            @click="showFilters = !showFilters"
            >
             <v-icon>{{ showFilters ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
             </v-btn>
        </v-card-title>
          <v-expand-transition>
      <div v-show="showFilters">
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="4">
              <v-combobox
                v-model="vehicle"
                :items="uniq(quotes, 'vehicle')"
                prepend-icon="mdi-truck"
                label="Όχημα"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(vehicle, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                v-model="customer"
                :items="customers"
                label="Πελάτης"
                item-text="customer.Name"
                item-value="customer.Name"
                prepend-icon="mdi-account"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  label="Ημερομηνίες"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filter_dates"
                @input="menu = false"
                range
                event-color="orange lighten-1"
                :events="functionEvents"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
    </div>
    </v-expand-transition>
      </v-card>
    </template>

  <template>
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Προσφορές</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="showHeaders"
      :items="quotes"
      :search="search"
      loading: false
      :sort-by="['qdate', 'quote_id']"
      :sort-desc="[true, true]"
      item-key="sha"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
      show-group-by
    >
<template v-slot:top>
      <v-toolbar
        flat
      >
        <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="mb-2"
              :to="{name: 'quote-create'} "
            >
              Νεα Προσφορα
            </v-btn>
      </v-toolbar>
  </template>
     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          :to="'/quote/edit/'+item.sha"
        >
         <v-icon>mdi-pencil</v-icon>
        </v-btn>
     <v-btn
          icon
          :href="$api.defaults.baseURL+'/quotes/pdf/'+item.sha"
          target="_blank"
        >
         <v-icon>mdi-file-pdf-box</v-icon>
        </v-btn>
       <!--    <v-btn
          icon
          :href="'http://localhost:8999/quotes/word/'+item.quoteid"
          target="_blank"
        >
         <v-icon>mdi-file-word</v-icon>
        </v-btn> -->
     </template>

    <template v-slot:item.qdate="{ item }">
      <v-tooltip top>
       <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >
        {{ item.qdate }}
        </span>
      </template>
       <span>Τελευταία τροπ. {{item.last_edit}}</span>
      </v-tooltip>
    </template>
    <template v-slot:item.version="{ item }">
      {{ item.versions.length }}
    </template>
    <template v-slot:item.net_value="{ item }">
       {{ tocurr(item.net_value) }}
    </template>
    <template v-slot:item.total_value="{ item }">
       {{ tocurr(item.total_value) }}
    </template>
    <template v-slot:item.vat_value="{ item }">
       {{ tocurr(item.vat_value) }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        Πληροφορίες για προσφορά {{ item.quote_id }}<br/>
        Αυτή η προσφορά έχει {{item.versions.length}} εκδόσεις.<br/>

        Οι εκδόσεις είναι:
          <v-list-item v-for='i in item.versions' :key=i>
            <v-list-item-content>
             <v-list-item-title> {{ i }}
               <v-btn
                    icon
                    :to="'/quote/'+i+'/edit'"
                  >
                  <v-icon>mdi-git</v-icon>
                  </v-btn>
             </v-list-item-title>
            </v-list-item-content>
            </v-list-item>

      </td>
    </template>

    </v-data-table>
  </v-card>
</template>
  </v-container>
</template>

<script>

//import QuoteCard from '../../components/QuoteCard.vue';
import uniqBy from "lodash/uniqBy"

export default {
  components: {
 //   QuoteCard
  },
  computed: {
      dateRangeText () {
        return this.filter_dates.join(' ~ ')
      },
      customers () {
        return uniqBy(this.quotes, 'customer.Name')
      },
      showHeaders() {
        if (this.$vuetify.breakpoint.smAndDown) {
            return this.headers.filter(h => !(['Id', 'version', 'net_value', 'vat_value']).includes(h.value));
        } else {
            return this.headers;
        }
    },
  },
  data() {
    return {
      menu: false,
      expanded: [],
      dialog: false,
      showFilters: false,
      loading: true,
      balance: 0.0,
      info: {
        name: '',
        address: '',
        telephone:'',
        nino: '',
        doi: '',
        city: '',
      },
      customer: '',
      vehicle: [],
      filter_dates: [],
      search: '',
      customer_id: this.$route.params.gid,
      quotes: [],
      headers: [
          {
            text: 'Προσφορά',
            align: 'start',
            //sortable: false,
            value: 'quote_id',
            width: '10%',
          },
          { text: 'Πελάτης', value: 'customer.Name', width: '10%',
          filter: (value) => {
            if (!this.customer) return true;
            return value == this.customer;
            },
          },
          { text: 'Ημερομηνία', value: 'qdate', width: '10%',
            filter: (value) => {

              this.filter_dates.sort();
              if (this.filter_dates == 0) return true;
              if (this.filter_dates.length == 1) return value == this.filter_dates[0];
              if (this.filter_dates.length == 2) {
                return  this.checkDates(value);
              }
            },
          },
          { text: 'Οχημα', value: 'vehicle',
          filter: (value) => {
            if (this.vehicle.length == 0) return true;
            return this.vehicle.includes(value);
            },
          },
          { text: 'Έκδοση', value: 'version', align: 'end', groupable: false },
          { text: 'SHA', value: 'sha', align: 'end', groupable: false },
          { text: 'Καθαρή αξία', value: 'net_value', align: 'end', groupable: false },
          { text: 'ΦΠΑ', value: 'vat_value', align: 'end' , groupable: false},
          { text: 'Συνολο', value: 'total_value', align: 'end', groupable: false },
          { text: 'Actions', value: 'actions', groupable: false, width: '5%' },
          { text: '', value: 'data-table-expand', groupable: false, },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/quotes/');
        // console.log(response);
        this.quotes = response.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  checkDates (date) {
    let d = new Date(date).getTime();
    let f = new Date(this.filter_dates[0]).getTime();
    let t = new Date(this.filter_dates[1]).getTime();
    //console.log(d, f, t)
    if (d >= f && d <= t) return true;
    return false;
  },
  functionEvents (date) {
    return this.quotes.some(e => e.qdate == date);
  },
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },

  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },
  }
}
</script>
